/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

// This code is auto-generated by Plasmic; please do not edit!
// Plasmic Project: fuzE93KTc4ZKNBYf3LAfy

import { createUseGlobalVariants } from "@plasmicapp/react-web";

import { useScreenVariants as useScreenVariantsiyzVSfo1WhzCb } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: IyzVSfo1whzCb/globalVariant

export const _useGlobalVariants = createUseGlobalVariants({
  screen: useScreenVariantsiyzVSfo1WhzCb,
});
